import { render, staticRenderFns } from "./GlobalRetailersDocs.vue?vue&type=template&id=932fbf10&"
import script from "./GlobalRetailersDocs.vue?vue&type=script&lang=js&"
export * from "./GlobalRetailersDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports